import { useQuery } from '@tanstack/react-query';
import { garmentJobsPath } from '@core/api/queryPaths';
import type { GarmentJobKind } from './generated/enums';
import { apiFetch } from './client';

// The types live in the shared core (docs/Mobile_Apps_Design.md); re-exported so imports stay put.
export type * from '@core/api/garmentJobs';
import type { GarmentJob } from '@core/api/garmentJobs';
export const garmentJobsKey = ['garment-job'] as const;

export function useGarmentJobs(kind: GarmentJobKind, includeClosed = false) {
  return useQuery({
    queryKey: [...garmentJobsKey, { kind, includeClosed }],
    queryFn: () => apiFetch<GarmentJob[]>(garmentJobsPath(kind, includeClosed)),
  });
}
